<template>
  <div class="container-wrapper">
    <div class="breadcrumb-wrapper">广告管理新版</div>

    <div class="ad-main-offset">
      <div class="ad-tip">
        <div class="ad-tip__title">广告策略说明</div>
        <div class="ad-tip__content">
          <div>当同一个广告位匹配到多条策略时，展示逻辑如下：</div>
          <div>1、若有1条策略命中【不展示】，则该广告位不展示广告；</div>
          <div>2、若没有策略命中【不展示】，则该广告位展示广告，且广告展示间隔分别按冷启/热启，取时间间隔最大的一条策略；</div>
          <div class="ad-tip__example">
            例：用户王小明，属于 XX 校区的 XX 人群，同一条广告位若同时命中多条策略时，按上述规则确定是否展示及展示间隔。
          </div>
        </div>
      </div>

      <el-tabs v-model="activeTab" class="ad-tabs">
        <el-tab-pane name="strategy">
          <span slot="label" class="ad-tab-label" :class="{ 'is-active': activeTab === 'strategy' }">广告策略</span>
        <div class="block-title">默认策略</div>
        <div class="content-wrapper">
          <el-table :data="defaultTableData" class="ad-table">
          <el-table-column prop="name" label="策略名称" min-width="140" align="center" />
          <el-table-column
            label="生效时间"
            min-width="220"
            align="center"
            class-name="cell-effect-time"
            label-class-name="cell-effect-time"
          >
            <template slot-scope="scope">
              <div class="effect-time-cell">
                <template v-if="scope.row.effectTime === '永久'">永久</template>
                <template v-else-if="scope.row.effectTimeStart && scope.row.effectTimeEnd">
                  <div>{{ scope.row.effectTimeStart }}</div>
                  <div class="effect-time-cell__end">~{{ scope.row.effectTimeEnd }}</div>
                </template>
                <template v-else>{{ scope.row.effectTime }}</template>
              </div>
            </template>
          </el-table-column>
          <el-table-column prop="crowd" label="适用人群" min-width="200" align="center" />
          <el-table-column label="状态" min-width="100" align="center">
            <template slot-scope="scope">
              <span class="ad-status" :class="statusRowClass(scope.row.status)">
                <i class="ad-status__dot"></i>
                <span class="ad-status__text">{{ strategyStatusText(scope.row) }}</span>
              </span>
            </template>
          </el-table-column>
          <el-table-column label="开屏" min-width="200" align="center">
            <template slot-scope="scope">
              <div class="ad-slot-cell">
                <template v-if="isColdHotIntervalSlot(scope.row.openScreen)">
                  <div class="ad-slot-line"><span class="ad-slot-tag">冷启</span>{{ scope.row.openScreen.cold }}</div>
                  <div class="ad-slot-line"><span class="ad-slot-tag">热启</span>{{ scope.row.openScreen.hot }}</div>
                </template>
                <span v-else>{{ scope.row.openScreen }}</span>
              </div>
            </template>
          </el-table-column>
          <el-table-column label="首页-插屏" min-width="200" align="center">
            <template slot-scope="scope">
              <div class="ad-slot-cell">
                <template v-if="isColdHotIntervalSlot(scope.row.homePop)">
                  <div class="ad-slot-line"><span class="ad-slot-tag">冷启</span>{{ scope.row.homePop.cold }}</div>
                  <div class="ad-slot-line"><span class="ad-slot-tag">热启</span>{{ scope.row.homePop.hot }}</div>
                </template>
                <span v-else>{{ scope.row.homePop }}</span>
              </div>
            </template>
          </el-table-column>
          <el-table-column label="跑步结束-插屏" min-width="210" align="center">
            <template slot-scope="scope">
              <div class="ad-slot-cell">
                <template v-if="isColdHotIntervalSlot(scope.row.runEndPop)">
                  <div class="ad-slot-line"><span class="ad-slot-tag">冷启</span>{{ scope.row.runEndPop.cold }}</div>
                  <div class="ad-slot-line"><span class="ad-slot-tag">热启</span>{{ scope.row.runEndPop.hot }}</div>
                </template>
                <span v-else>{{ scope.row.runEndPop }}</span>
              </div>
            </template>
          </el-table-column>
          <el-table-column prop="homeFeed" label="首页-信息流" min-width="190" align="center" class-name="cell-nowrap" label-class-name="cell-nowrap" />
          <el-table-column prop="runEndFeed" label="跑步结束-信息流" min-width="200" align="center" class-name="cell-nowrap" label-class-name="cell-nowrap" />
          <el-table-column prop="mineFeed" label="我的-信息流" min-width="170" align="center" class-name="cell-nowrap" label-class-name="cell-nowrap" />
          <el-table-column prop="floatingWindow" label="悬浮窗" min-width="120" align="center" class-name="cell-nowrap" label-class-name="cell-nowrap" />
          <el-table-column prop="effectiveSystemText" label="生效系统" min-width="100" align="center" />
          <el-table-column prop="scope" label="适用校区" min-width="100" align="center" />
          <el-table-column prop="updateAt" label="操作时间" min-width="180" align="center" />
          <el-table-column prop="operator" label="操作人" min-width="120" align="center" />
          <el-table-column
            label="操作"
            min-width="240"
            align="center"
            class-name="column-op"
            label-class-name="column-op"
          >
            <template slot-scope="scope">
              <div class="op-btns">
                <el-button type="text" @click="handleEdit(scope.row)">编辑</el-button>
                <el-button type="text" @click="handleLinkCrowd(scope.row)">关联人群</el-button>
                <el-button type="text" @click="handleLinkCampus(scope.row)">关联校区</el-button>
              </div>
            </template>
          </el-table-column>
          </el-table>
          <div class="pagination-row">
            <el-pagination
              background
              :current-page="defaultPagination.page"
              :page-size="defaultPagination.pageSize"
              layout="prev, pager, next, jumper, sizes, total"
              :total="defaultPagination.total"
              @current-change="handleDefaultPageChange"
              @size-change="handleDefaultSizeChange"
            />
          </div>
        </div>

        <div class="block-title custom-strategy-title">自定义策略</div>

        <div class="content-wrapper">
        <div class="filter-row filter-row--custom-strategy">
          <el-input v-model="filters.name" placeholder="策略名称" clearable class="filter-item" />
          <el-select v-model="filters.status" class="filter-item" placeholder="策略状态">
            <el-option label="全部" value="" />
            <el-option label="待生效" value="pending" />
            <el-option label="生效中" value="active" />
            <el-option label="已过期" value="expired" />
          </el-select>
          <el-button type="primary" @click="queryCustomList">搜索</el-button>
          <el-button type="primary" plain class="btn-add-custom-strategy" @click="handleAddCustom">+新增自定义策略</el-button>
        </div>

        <el-table :data="customTableData" class="ad-table">
          <el-table-column prop="name" label="策略名称" min-width="140" align="center" />
          <el-table-column
            label="生效时间"
            min-width="220"
            align="center"
            class-name="cell-effect-time"
            label-class-name="cell-effect-time"
          >
            <template slot-scope="scope">
              <div class="effect-time-cell">
                <template v-if="scope.row.effectTime === '永久'">永久</template>
                <template v-else-if="scope.row.effectTimeStart && scope.row.effectTimeEnd">
                  <div>{{ scope.row.effectTimeStart }}</div>
                  <div class="effect-time-cell__end">~{{ scope.row.effectTimeEnd }}</div>
                </template>
                <template v-else>{{ scope.row.effectTime }}</template>
              </div>
            </template>
          </el-table-column>
          <el-table-column prop="crowd" label="适用人群" min-width="200" align="center" />
          <el-table-column label="状态" min-width="100" align="center">
            <template slot-scope="scope">
              <span class="ad-status" :class="statusRowClass(scope.row.status)">
                <i class="ad-status__dot"></i>
                <span class="ad-status__text">{{ strategyStatusText(scope.row) }}</span>
              </span>
            </template>
          </el-table-column>
          <el-table-column label="开屏" min-width="200" align="center">
            <template slot-scope="scope">
              <div class="ad-slot-cell">
                <template v-if="isColdHotIntervalSlot(scope.row.openScreen)">
                  <div class="ad-slot-line"><span class="ad-slot-tag">冷启</span>{{ scope.row.openScreen.cold }}</div>
                  <div class="ad-slot-line"><span class="ad-slot-tag">热启</span>{{ scope.row.openScreen.hot }}</div>
                </template>
                <span v-else>{{ scope.row.openScreen }}</span>
              </div>
            </template>
          </el-table-column>
          <el-table-column label="首页-插屏" min-width="200" align="center">
            <template slot-scope="scope">
              <div class="ad-slot-cell">
                <template v-if="isColdHotIntervalSlot(scope.row.homePop)">
                  <div class="ad-slot-line"><span class="ad-slot-tag">冷启</span>{{ scope.row.homePop.cold }}</div>
                  <div class="ad-slot-line"><span class="ad-slot-tag">热启</span>{{ scope.row.homePop.hot }}</div>
                </template>
                <span v-else>{{ scope.row.homePop }}</span>
              </div>
            </template>
          </el-table-column>
          <el-table-column label="跑步结束-插屏" min-width="210" align="center">
            <template slot-scope="scope">
              <div class="ad-slot-cell">
                <template v-if="isColdHotIntervalSlot(scope.row.runEndPop)">
                  <div class="ad-slot-line"><span class="ad-slot-tag">冷启</span>{{ scope.row.runEndPop.cold }}</div>
                  <div class="ad-slot-line"><span class="ad-slot-tag">热启</span>{{ scope.row.runEndPop.hot }}</div>
                </template>
                <span v-else>{{ scope.row.runEndPop }}</span>
              </div>
            </template>
          </el-table-column>
          <el-table-column prop="homeFeed" label="首页-信息流" min-width="190" align="center" class-name="cell-nowrap" label-class-name="cell-nowrap" />
          <el-table-column prop="runEndFeed" label="跑步结束-信息流" min-width="200" align="center" class-name="cell-nowrap" label-class-name="cell-nowrap" />
          <el-table-column prop="mineFeed" label="我的-信息流" min-width="170" align="center" class-name="cell-nowrap" label-class-name="cell-nowrap" />
          <el-table-column prop="floatingWindow" label="悬浮窗" min-width="120" align="center" class-name="cell-nowrap" label-class-name="cell-nowrap" />
          <el-table-column prop="effectiveSystemText" label="生效系统" min-width="100" align="center" />
          <el-table-column prop="scope" label="适用校区" min-width="120" align="center" />
          <el-table-column prop="updateAt" label="操作时间" min-width="180" align="center" />
          <el-table-column prop="operator" label="操作人" min-width="120" align="center" />
          <el-table-column
            label="操作"
            min-width="240"
            align="center"
            class-name="column-op"
            label-class-name="column-op"
          >
            <template slot-scope="scope">
              <div class="op-btns op-btns--wrap">
                <el-button type="text" @click="handleEdit(scope.row)">编辑</el-button>
                <el-button type="text" @click="handleCopy(scope.row)">复制</el-button>
                <el-button type="text" @click="handleLinkCrowd(scope.row)">关联人群</el-button>
                <el-button type="text" @click="handleLinkCampus(scope.row)">关联校区</el-button>
                <el-button type="text" class="danger-text" @click="handleDelete(scope.row)">删除</el-button>
              </div>
            </template>
          </el-table-column>
        </el-table>

          <div class="pagination-row">
            <el-pagination
              background
              :current-page="pagination.page"
              :page-size="pagination.pageSize"
              layout="prev, pager, next, jumper, sizes, total"
              :total="pagination.total"
              @current-change="handlePageChange"
              @size-change="handleSizeChange"
            />
          </div>
        </div>
        </el-tab-pane>

        <el-tab-pane name="crowd">
          <span slot="label" class="ad-tab-label" :class="{ 'is-active': activeTab === 'crowd' }">人群圈定</span>
        <div class="block-title">默认人群</div>
        <div class="content-wrapper">
          <el-table ref="defaultCrowdTableRef" :data="defaultCrowdRows" class="ad-table ad-table--crowd">
            <el-table-column prop="name" label="人群名称" width="120" align="left" />
            <el-table-column prop="description" label="人群说明" min-width="420" align="left" show-overflow-tooltip />
          </el-table>
        </div>

        <div class="crowd-custom-row">
          <div class="block-title crowd-custom-row__title">自定义人群</div>
          <el-button type="primary" plain class="btn-add-custom-strategy" @click="handleAddCustomCrowd">
            + 新增自定义人群
          </el-button>
        </div>
        <div class="content-wrapper">
          <el-table ref="customCrowdTableRef" :data="customCrowdTableData" class="ad-table ad-table--crowd">
            <el-table-column prop="name" label="人群名称" min-width="130" align="left" />
            <el-table-column prop="description" label="人群说明" min-width="180" align="left" show-overflow-tooltip />
            <el-table-column label="是否学校任务跑用户" min-width="180" align="left">
              <template slot-scope="scope">
                {{ scope.row.isSchoolRunUser ? "是" : "否" }}
              </template>
            </el-table-column>
            <el-table-column label="学期是否开始" min-width="120" align="left">
              <template slot-scope="scope">
                {{ scope.row.semesterStartedLabel }}
              </template>
            </el-table-column>
            <el-table-column label="是否有校园跑学期目标" min-width="200" align="left">
              <template slot-scope="scope">
                {{ scope.row.hasCampusRunSemesterGoalLabel }}
              </template>
            </el-table-column>
            <el-table-column prop="semesterGoalProgress" label="校园跑学期目标进度" min-width="200" align="left" show-overflow-tooltip />
            <el-table-column label="跑步时段" min-width="220" align="left" class-name="column-running-time">
              <template slot-scope="scope">
                <div class="running-time-slot-cell">
                  <template v-if="scope.row.runningTimeSlotParts.type === 'dash'">—</template>
                  <template v-else-if="scope.row.runningTimeSlotParts.type === 'raw'">
                    {{ scope.row.runningTimeSlotParts.text }}
                  </template>
                  <template v-else-if="scope.row.runningTimeSlotParts.type === 'pair'">
                    <div
                      v-if="scope.row.runningTimeSlotParts.dayStr"
                      class="running-time-slot-cell__days"
                    >
                      {{ scope.row.runningTimeSlotParts.dayStr }}
                    </div>
                    <div
                      v-if="scope.row.runningTimeSlotParts.timeStr"
                      class="running-time-slot-cell__time"
                    >
                      {{ scope.row.runningTimeSlotParts.timeStr }}
                    </div>
                  </template>
                </div>
              </template>
            </el-table-column>
            <el-table-column label="操作" min-width="120" align="left">
              <template slot-scope="scope">
                <div class="op-btns op-btns--left">
                  <el-button type="text" @click="handleCrowdEdit(scope.row)">编辑</el-button>
                  <el-button type="text" class="danger-text" @click="handleCrowdDelete(scope.row)">删除</el-button>
                </div>
              </template>
            </el-table-column>
          </el-table>

          <div class="pagination-row">
            <el-pagination
              background
              :current-page="crowdPagination.page"
              :page-size="crowdPagination.pageSize"
              layout="prev, pager, next, jumper, sizes, total"
              :total="crowdPagination.total"
              @current-change="handleCrowdPageChange"
              @size-change="handleCrowdSizeChange"
            />
          </div>
        </div>
        </el-tab-pane>
      </el-tabs>

      <ad-add-strategy-dialog
        :visible.sync="addDialogVisible"
        :edit-strategy-id="strategyDialogEditId"
        :duplicate-name-exclude="strategyDialogNameExclude"
        :strategy-prefill-dto.sync="strategyPrefillDto"
        :existing-strategy-names="existingStrategyNames"
        :CampusZoneList="CampusZoneList"
        @saved="handleStrategyDialogSaved"
      />
      <link-crowd-dialog ref="linkCrowdDialogRef" @saved="handleLinkCrowdSaved" />
      <link-campus-dialog ref="linkCampusDialogRef" :campus-zone-list="CampusZoneList" @saved="handleLinkCampusSaved" />
      <ad-add-crowd-dialog
        :visible.sync="addCrowdDialogVisible"
        :crowd-id="crowdDialogCrowdId"
        :initial-crowd-dto="crowdDialogInitialDto"
        :existing-crowd-names="existingCrowdNamesForDialog"
        @saved="handleAddCrowdSaved"
      />
    </div>
  </div>
</template>

<script>
import AdAddStrategyDialog from "./Components/AdAddStrategyDialog.vue";
import AdAddCrowdDialog from "./Components/AdAddCrowdDialog.vue";
import LinkCrowdDialog from "./Components/LinkCrowdDialog.vue";
import LinkCampusDialog from "./Components/LinkCampusDialog.vue";

const API_SUCCESS = 10000;
const UNIT_LABELS = ["", "秒", "分钟", "小时", "天"];

function unitLabel(u) {
  return UNIT_LABELS[u] || "秒";
}

function effectiveStatusToUi(status) {
  const map = { 0: "pending", 1: "active", 2: "expired" };
  return map[status] != null ? map[status] : "pending";
}

function effectiveStatusToText(status) {
  const map = { 0: "待生效", 1: "生效中", 2: "已过期" };
  return map[status] != null ? map[status] : "—";
}

function uiFilterStatusToEffectiveType(ui) {
  const map = { "": 0, pending: 1, active: 2, expired: 3 };
  return map[ui] != null ? map[ui] : 0;
}

function effectiveSystemToText(system) {
  const map = { 0: "全部", 1: "iOS", 2: "鸿蒙", 3: "安卓" };
  return map[system] != null ? map[system] : "全部";
}

function formatSlotPop(slot) {
  if (!slot || slot.isShow === 0) return "不展示";
  return {
    cold: `${slot.coldStartInterval != null ? slot.coldStartInterval : 0} ${unitLabel(slot.coldStartUnit)}`,
    hot: `${slot.hotStartInterval != null ? slot.hotStartInterval : 0} ${unitLabel(slot.hotStartUnit)}`,
  };
}

function formatSlotFeed(slot) {
  if (!slot || slot.isShow === 0) return "不展示";
  return "展示";
}

function mapStrategyDtoToTableRow(dto) {
  const formatDate = (date, format) => {
    format = format || "yyyy-MM-dd hh:mm:ss";
    if (!date || isNaN(date.getTime())) return "";
    let o = {
      "M+": date.getMonth() + 1,
      "d+": date.getDate(),
      "h+": date.getHours(),
      "m+": date.getMinutes(),
      "s+": date.getSeconds(),
      "q+": Math.floor((date.getMonth() + 3) / 3),
      S: date.getMilliseconds(),
    };
    if (/(y+)/.test(format)) {
      format = format.replace(
        RegExp.$1,
        (date.getFullYear() + "").substr(4 - RegExp.$1.length)
      );
    }
    for (let k in o) {
      if (new RegExp("(" + k + ")").test(format)) {
        format = format.replace(
          RegExp.$1,
          RegExp.$1.length === 1 ? o[k] : ("00" + o[k]).substr(String(o[k]).length)
        );
      }
    }
    return format;
  };

  // 将后端毫秒时间戳（如 1774405019000）转换成展示用日期字符串
  const formatTimestamp = (value) => {
    if (value === null || value === undefined || value === "") return "—";

    // 兼容字符串数字
    let n = value;
    if (typeof value === "string") {
      const trimmed = value.trim();
      if (!trimmed) return "—";
      if (!/^\d+(\.\d+)?$/.test(trimmed)) return trimmed;
      n = Number(trimmed);
    }

    if (typeof n !== "number" || !Number.isFinite(n)) return "—";

    // 区分秒/毫秒：秒是 10 位左右，毫秒是 13 位左右（阈值按年份大致区分）
    const ts = n < 100000000000 ? n * 1000 : n;
    const d = new Date(ts);
    return formatDate(d) || "—";
  };

  const slotByType = {};
  (dto.slotConfigs || []).forEach((s) => {
    if (s && s.slotType != null) slotByType[s.slotType] = s;
  });

  const startRaw = dto.effectiveTimeType === 1 ? "" : dto.effectiveStartTime;
  const endRaw = dto.effectiveTimeType === 1 ? "" : dto.effectiveEndTime;
  const start = startRaw && String(startRaw).trim() ? String(startRaw).trim() : "";
  const end = endRaw && String(endRaw).trim() ? String(endRaw).trim() : "";

  let effectTime = "—";
  if (dto.effectiveTimeType === 1) {
    effectTime = "永久";
  } else if (start && end) {
    effectTime = `${start}\n${end}`;
  } else {
    effectTime = [start, end].filter(Boolean).join(" - ") || "—";
  }

  const crowdNames = (dto.crowdIds || []).map((c) => c.crowdName || "").filter(Boolean);
  const crowd = crowdNames.join("、") || "—";

  const campusList = dto.campusIds || [];
  const scope = dto.campusScope === 1 ? "全校" : `已配置 ${campusList.length} 个校区`;

  const campusModels = campusList.map((c) => ({
    unid: c.id,
    name: c.campusName,
  }));

  const st = dto.effectiveStatus;

  return {
    id: dto.id,
    /** 列表项上的完整 DTO，用于「复制」打开新增弹窗预填（不调复制接口） */
    strategySourceDto: JSON.parse(JSON.stringify(dto)),
    name: dto.strategyName,
    effectTime,
    /** 有开始、结束时间时分两行展示（见模板） */
    effectTimeStart: dto.effectiveTimeType !== 1 && start ? start : "",
    effectTimeEnd: dto.effectiveTimeType !== 1 && end ? end : "",
    crowd,
    crowdIds: (dto.crowdIds || []).map((c) => c.id).filter((x) => x != null),
    status: effectiveStatusToUi(st),
    statusText: effectiveStatusToText(st),
    openScreen: formatSlotPop(slotByType[1]),
    homePop: formatSlotPop(slotByType[2]),
    runEndPop: formatSlotPop(slotByType[3]),
    homeFeed: formatSlotFeed(slotByType[4]),
    runEndFeed: formatSlotFeed(slotByType[5]),
    mineFeed: formatSlotFeed(slotByType[6]),
    floatingWindow: formatSlotFeed(slotByType[7]),
    effectiveSystemText: effectiveSystemToText(dto.effectiveSystem),
    scope,
    campusScope: dto.campusScope === 1 ? "all" : "partial",
    campusModels,
    updateAt: formatTimestamp(dto.updateTime),
    operator: dto.createBy || "—",
    strategyType: dto.strategyType,
  };
}

const WEEK_LABELS = ["", "周一", "周二", "周三", "周四", "周五", "周六", "周日"];

/**
 * 连续工作日展示：仅当一段连续天数 >3（≥4 天）时用「周一~周四」；
 * 连续 2～3 天用顿号「周一、周二、周三」；不连续的多段用「、」拼接。
 * 例：[1,2,4,5] →「周一、周二、周四、周五」（两段各 2 天，均不用 ~）
 */
function formatConsecutiveWeekSegment(start, end) {
  const len = end - start + 1;
  if (len <= 1) return WEEK_LABELS[start];
  if (len <= 3) {
    const labels = [];
    for (let d = start; d <= end; d++) labels.push(WEEK_LABELS[d]);
    return labels.join("、");
  }
  return `${WEEK_LABELS[start]}~${WEEK_LABELS[end]}`;
}

function formatWeekDaysCompact(weekDays) {
  const sorted = [...new Set(weekDays)]
    .filter((d) => d >= 1 && d <= 7)
    .sort((a, b) => a - b);
  if (!sorted.length) return "";
  const parts = [];
  let rangeStart = sorted[0];
  let prev = sorted[0];
  for (let i = 1; i < sorted.length; i++) {
    const cur = sorted[i];
    if (cur === prev + 1) {
      prev = cur;
      continue;
    }
    parts.push(formatConsecutiveWeekSegment(rangeStart, prev));
    rangeStart = cur;
    prev = cur;
  }
  parts.push(formatConsecutiveWeekSegment(rangeStart, prev));
  return parts.join("、");
}

/** 兼容标准 JSON 与未给 key 加引号的字符串，如 {weekDays:[1,2,3],timeType:2,startTime:07:00,endTime:09:00} */
function parseRunningTimeConfigLoose(str) {
  if (!str || typeof str !== "string") return null;
  const trimmed = str.trim();
  try {
    return JSON.parse(trimmed);
  } catch (e) {
    try {
      let s = trimmed;
      if (!s.startsWith("{")) return null;
      s = s.replace(/([{,]\s*)([a-zA-Z_][a-zA-Z0-9_]*)\s*:/g, '$1"$2":');
      s = s.replace(/:\s*(\d{2}:\d{2})(?=\s*[,}])/g, ':"$1"');
      return JSON.parse(s);
    } catch (e2) {
      return null;
    }
  }
}

/**
 * 解析跑步时段用于表格展示：星期与具体时段拆开，便于星期换行、时段整行不换行。
 * @returns {{ type: 'dash' } | { type: 'raw', text: string } | { type: 'pair', dayStr: string, timeStr: string }}
 */
function parseRunningTimeSlotDisplay(runningTimeConfig) {
  if (!runningTimeConfig || typeof runningTimeConfig !== "string") {
    return { type: "dash" };
  }
  const o = parseRunningTimeConfigLoose(runningTimeConfig);
  if (!o || typeof o !== "object") {
    return { type: "raw", text: runningTimeConfig };
  }

  const dayStr = formatWeekDaysCompact(o.weekDays || []);
  const timeType = o.timeType;
  let timeStr = "—";
  if (timeType === 1 || timeType == null) {
    timeStr = "全天";
  } else {
    const st = o.startTime != null ? String(o.startTime).trim() : "";
    const et = o.endTime != null ? String(o.endTime).trim() : "";
    if (st && et) timeStr = `${st}~${et}`;
    else if (st || et) timeStr = st || et;
  }

  if (!dayStr && timeStr === "—") return { type: "dash" };
  if (!dayStr) return { type: "pair", dayStr: "", timeStr };
  if (timeStr === "—") return { type: "pair", dayStr, timeStr: "" };
  return { type: "pair", dayStr, timeStr };
}

function formatRunningTimeSlotFromParts(p) {
  if (!p || p.type === "dash") return "—";
  if (p.type === "raw") return p.text;
  const { dayStr, timeStr } = p;
  if (!dayStr && !timeStr) return "—";
  if (!dayStr) return timeStr;
  if (!timeStr) return dayStr;
  return `${dayStr}，${timeStr}`;
}

function formatRunningTimeSlot(runningTimeConfig) {
  return formatRunningTimeSlotFromParts(parseRunningTimeSlotDisplay(runningTimeConfig));
}

function mapCrowdDtoToTableRow(d) {
  let semesterStartedLabel = "—";
  if (d.isSemesterStarted === 2) semesterStartedLabel = "不限";
  else if (d.isSemesterStarted === 1) semesterStartedLabel = "是";
  else if (d.isSemesterStarted === 0) semesterStartedLabel = "否";

  /** hasSemesterGoal：是否有校园跑学期目标（0 否 / 1 是 / 2 不限） */
  let hasCampusRunSemesterGoalLabel = "—";
  if (d.hasSemesterGoal === 2) hasCampusRunSemesterGoalLabel = "不限";
  else if (d.hasSemesterGoal === 0) hasCampusRunSemesterGoalLabel = "否";
  else if (d.hasSemesterGoal === 1) hasCampusRunSemesterGoalLabel = "是";

  /** semesterGoalProgress：目标进度要求（%，仅当「是」且大于 0 时展示；否则 --） */
  let semesterGoalProgress = "--";
  if (d.hasSemesterGoal === 1) {
    const p =
      d.semesterGoalProgress != null && d.semesterGoalProgress !== ""
        ? Number(d.semesterGoalProgress)
        : NaN;
    semesterGoalProgress = !Number.isNaN(p) && p > 0 ? `≥${p}%` : "--";
  }

  const rtp = parseRunningTimeSlotDisplay(d.runningTimeConfig);
  return {
    id: d.id,
    name: d.crowdName,
    description: d.crowdDesc,
    isSchoolRunUser: d.isSchoolTaskUser === 1,
    semesterStartedLabel,
    hasCampusRunSemesterGoalLabel,
    semesterGoalProgress,
    runningTimeSlotParts: rtp,
    runningTimeSlot: formatRunningTimeSlotFromParts(rtp),
    /** 列表接口原始字段，编辑人群弹窗回显用 */
    crowdDto: d,
  };
}

function normalizeListResponse(data) {
  if (!data) return [];
  if (Array.isArray(data)) return data;
  if (Array.isArray(data.list)) return data.list;
  return [];
}

export default {
  name: "AdManagementNew",
  components: {
    AdAddStrategyDialog,
    AdAddCrowdDialog,
    LinkCrowdDialog,
    LinkCampusDialog,
  },
  data() {
    return {
      activeTab: "strategy",
      filters: {
        name: "",
        status: "",
      },
      defaultPagination: {
        page: 1,
        pageSize: 10,
        total: 0,
      },
      pagination: {
        page: 1,
        pageSize: 10,
        total: 0,
      },
      crowdPagination: {
        page: 1,
        pageSize: 10,
        total: 0,
      },
      defaultCrowdRows: [
        {
          name: "大众人群",
          description: "没有绑定学校，或者绑定了「未签约高校」的用户",
        },
        {
          name: "非校园跑用户",
          description: "绑定了已签约高校，但不属于学校任务跑的用户",
        },
        {
          name: "校园跑用户",
          description: "绑定了已签约高校，且属于学校任务跑的用户",
        },
      ],
      defaultTableData: [],
      customTableData: [],
      customCrowdTableData: [],

      addDialogVisible: false,
      strategyDialogEditId: null,
      strategyDialogNameExclude: "",
      /** 从「复制」带入的新增预填数据，消费后由弹窗置空 */
      strategyPrefillDto: null,
      addCrowdDialogVisible: false,
      crowdDialogCrowdId: null,
      crowdDialogInitialDto: null,
      crowdDialogOriginalName: "",
      existingStrategyNames: [],
      existingCrowdNamesList: [],
      CampusZoneList: [],
    };
  },
  computed: {
    existingCrowdNamesForDialog() {
      const list = this.existingCrowdNamesList || [];
      const orig = (this.crowdDialogOriginalName || "").trim();
      if (this.crowdDialogCrowdId != null && orig) {
        return list.filter((n) => n !== orig);
      }
      return list;
    },
  },
  mounted() {
    this.apiGetCampusZones();
    this.queryDefaultStrategies();
    this.queryCustomList();
    this.queryCustomCrowdList();
    this.queryDefaultCrowdRows();
    this.$nextTick(() => {
      if (this.activeTab === "crowd") this.layoutCrowdTables();
    });
  },
  methods: {
    // 获取校区（与 AdManagement.vue 一致）
    apiGetCampusZones() {
      this.$http({
        url: this.$util.domain + "/adminapi/v1/basicTools/allCampusZones",
        method: "GET",
      })
        .then((res) => {
          if (res.body.data && res.body.data.length) {
            this.CampusZoneList = res.body.data.map((item) => ({
              label: item.name,
              value: item.unid,
            }));
          } else {
            this.CampusZoneList = [];
          }
        })
        .catch(() => {
          this.CampusZoneList = [];
        });
    },

    queryDefaultStrategies() {
      this.$http({
        url: this.$util.domain + "/adminapi/v1/ad/strategy/list",
        method: "POST",
        dataType: "json",
        body: JSON.stringify({
          strategyName: "",
          strategyType: 1,
          pageNum: this.defaultPagination.page,
          pageSize: this.defaultPagination.pageSize,
        }),
      })
        .then((res) => {
          if (res.body.error !== API_SUCCESS) {
            this.defaultTableData = [];
            this.defaultPagination.total = 0;
            return;
          }
          const data = res.body.data || {};
          this.defaultPagination.total = data.total || 0;
          this.defaultTableData = (data.list || []).map(mapStrategyDtoToTableRow);
        })
        .catch(() => {
          this.defaultTableData = [];
          this.defaultPagination.total = 0;
        });
    },
    handleDefaultPageChange(page) {
      this.defaultPagination.page = page;
      this.queryDefaultStrategies();
    },
    handleDefaultSizeChange(size) {
      this.defaultPagination.pageSize = size;
      this.defaultPagination.page = 1;
      this.queryDefaultStrategies();
    },
    queryCustomList() {
      const keyword = (this.filters.name || "").trim();
      this.$http({
        url: this.$util.domain + "/adminapi/v1/ad/strategy/list",
        method: "POST",
        dataType: "json",
        body: JSON.stringify({
          strategyName: keyword,
          strategyType: 2,
          effectiveType: uiFilterStatusToEffectiveType(this.filters.status),
          pageNum: this.pagination.page,
          pageSize: this.pagination.pageSize,
        }),
      })
        .then((res) => {
          if (res.body.error !== API_SUCCESS) {
            this.$message({
              type: "error",
              message: res.body.message || "查询失败",
            });
            this.customTableData = [];
            this.pagination.total = 0;
            return;
          }
          const data = res.body.data || {};
          this.pagination.total = data.total || 0;
          this.customTableData = (data.list || []).map(mapStrategyDtoToTableRow);
        })
        .catch(() => {
          this.customTableData = [];
          this.pagination.total = 0;
        });
    },
    queryDefaultCrowdRows() {
      this.$http({
        url: this.$util.domain + "/adminapi/v1/ad/crowd/all",
        method: "GET",
      })
        .then((res) => {
          if (res.body.error !== API_SUCCESS) return;
          let raw = normalizeListResponse(res.body.data);
          if (!raw.length && res.body.data && res.body.data.id != null) raw = [res.body.data];
          const defaults = raw.filter((c) => c.crowdType == null || c.crowdType === 1);
          if (!defaults.length) return;
          this.defaultCrowdRows = defaults.map((c) => ({
            name: c.crowdName,
            description: c.crowdDesc || "—",
          }));
        })
        .catch(() => {});
    },
    handleStrategyDialogSaved() {
      this.queryCustomList();
      this.queryDefaultStrategies();
    },
    handlePageChange(page) {
      this.pagination.page = page;
      this.queryCustomList();
    },
    handleSizeChange(size) {
      this.pagination.pageSize = size;
      this.pagination.page = 1;
      this.queryCustomList();
    },
    handleAddCustom() {
      this.strategyDialogEditId = null;
      this.strategyDialogNameExclude = "";
      this.strategyPrefillDto = null;
      this.$http({
        url: this.$util.domain + "/adminapi/v1/ad/strategy/list",
        method: "POST",
        dataType: "json",
        body: JSON.stringify({
          strategyName: "",
          strategyType: 2,
          effectiveType: 0,
          pageNum: 1,
          pageSize: 500,
        }),
      })
        .then((res) => {
          if (res.body.error === API_SUCCESS && res.body.data && res.body.data.list) {
            this.existingStrategyNames = res.body.data.list.map((i) => i.strategyName);
          }
          this.addDialogVisible = true;
        })
        .catch(() => {
          this.addDialogVisible = true;
        });
    },
    queryCustomCrowdList() {
      this.$http({
        url: this.$util.domain + "/adminapi/v1/ad/crowd/list",
        method: "POST",
        dataType: "json",
        body: JSON.stringify({
          crowdName: "",
          crowdType: 2,
          pageNum: this.crowdPagination.page,
          pageSize: this.crowdPagination.pageSize,
        }),
      })
        .then((res) => {
          if (res.body.error !== API_SUCCESS) {
            this.customCrowdTableData = [];
            this.crowdPagination.total = 0;
            return;
          }
          const data = res.body.data || {};
          this.crowdPagination.total = data.total || 0;
          const list = data.list || [];
          this.customCrowdTableData = list.map(mapCrowdDtoToTableRow);
          this.existingCrowdNamesList = list.map((c) => c.crowdName).filter(Boolean);
        })
        .catch(() => {
          this.customCrowdTableData = [];
          this.crowdPagination.total = 0;
        });
    },
    refreshCrowdNamesForDuplicate() {
      return this.$http({
        url: this.$util.domain + "/adminapi/v1/ad/crowd/list",
        method: "POST",
        dataType: "json",
        body: JSON.stringify({
          crowdName: "",
          crowdType: 2,
          pageNum: 1,
          pageSize: 500,
        }),
      }).then((res) => {
        if (res.body.error === API_SUCCESS && res.body.data && res.body.data.list) {
          this.existingCrowdNamesList = res.body.data.list.map((c) => c.crowdName).filter(Boolean);
        }
      });
    },
    layoutCrowdTables() {
      this.$nextTick(() => {
        const t1 = this.$refs.defaultCrowdTableRef;
        const t2 = this.$refs.customCrowdTableRef;
        if (t1 && typeof t1.doLayout === "function") t1.doLayout();
        if (t2 && typeof t2.doLayout === "function") t2.doLayout();
      });
    },
    handleCrowdPageChange(page) {
      this.crowdPagination.page = page;
      this.queryCustomCrowdList();
    },
    handleCrowdSizeChange(size) {
      this.crowdPagination.pageSize = size;
      this.crowdPagination.page = 1;
      this.queryCustomCrowdList();
    },
    handleAddCustomCrowd() {
      this.crowdDialogCrowdId = null;
      this.crowdDialogInitialDto = null;
      this.crowdDialogOriginalName = "";
      this.refreshCrowdNamesForDuplicate().finally(() => {
        this.addCrowdDialogVisible = true;
      });
    },
    handleAddCrowdSaved() {
      this.crowdDialogCrowdId = null;
      this.crowdDialogInitialDto = null;
      this.crowdDialogOriginalName = "";
      this.queryCustomCrowdList();
    },
    handleCrowdEdit(row) {
      if (!row || row.id == null) return;
      this.crowdDialogCrowdId = row.id;
      this.crowdDialogInitialDto = row.crowdDto ? { ...row.crowdDto } : null;
      this.crowdDialogOriginalName = (row.name || "").trim();
      this.refreshCrowdNamesForDuplicate().finally(() => {
        this.addCrowdDialogVisible = true;
      });
    },
    handleCrowdDelete(row) {
      this.$confirm("确认要删除该自定义人群吗？", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      }).then(() => {
        this.$http({
          url: `${this.$util.domain}/adminapi/v1/ad/crowd/delete/${row.id}`,
          method: "POST",
        }).then((res) => {
          if (res.body.error !== API_SUCCESS) {
            this.$message({
              type: "error",
              message: res.body.message || "删除失败",
            });
            return;
          }
          this.$message({
            type: "success",
            message: "删除成功",
          });
          this.queryCustomCrowdList();
        });
      });
    },
    handleEdit(row) {
      if (!row || row.id == null) return;
      this.strategyPrefillDto = null;
      this.strategyDialogEditId = row.id;
      this.strategyDialogNameExclude = (row.name || "").trim();
      this.$http({
        url: this.$util.domain + "/adminapi/v1/ad/strategy/list",
        method: "POST",
        dataType: "json",
        body: JSON.stringify({
          strategyName: "",
          strategyType: 2,
          effectiveType: 0,
          pageNum: 1,
          pageSize: 500,
        }),
      })
        .then((res) => {
          if (res.body.error === API_SUCCESS && res.body.data && res.body.data.list) {
            this.existingStrategyNames = res.body.data.list.map((i) => i.strategyName);
          }
          this.addDialogVisible = true;
        })
        .catch(() => {
          this.addDialogVisible = true;
        });
    },
    handleLinkCrowd(row) {
      this.$nextTick(() => {
        if (this.$refs.linkCrowdDialogRef) {
          this.$refs.linkCrowdDialogRef.show(row);
        }
      });
    },
    handleLinkCrowdSaved({ row, crowdText, crowdIds }) {
      if (!row) return;
      if (crowdText != null) this.$set(row, "crowd", crowdText);
      if (crowdIds && Array.isArray(crowdIds)) this.$set(row, "crowdIds", [...crowdIds]);
      this.queryCustomList();
      this.queryDefaultStrategies();
    },
    handleLinkCampus(row) {
      this.$nextTick(() => {
        if (this.$refs.linkCampusDialogRef) {
          this.$refs.linkCampusDialogRef.show(row);
        }
      });
    },
    handleLinkCampusSaved({ row, campusScope, campusModels, scopeText }) {
      if (!row) return;
      if (scopeText != null) this.$set(row, "scope", scopeText);
      this.$set(row, "campusScope", campusScope);
      this.$set(row, "campusModels", campusModels ? [...campusModels] : []);
      this.queryCustomList();
      this.queryDefaultStrategies();
    },
    handleCopy(row) {
      if (!row || !row.strategySourceDto) {
        return this.$message.warning("无法复制，请刷新列表后重试");
      }
      this.strategyDialogEditId = null;
      this.strategyDialogNameExclude = "";
      this.strategyPrefillDto = JSON.parse(JSON.stringify(row.strategySourceDto));
      this.$http({
        url: this.$util.domain + "/adminapi/v1/ad/strategy/list",
        method: "POST",
        dataType: "json",
        body: JSON.stringify({
          strategyName: "",
          strategyType: 2,
          effectiveType: 0,
          pageNum: 1,
          pageSize: 500,
        }),
      })
        .then((res) => {
          if (res.body.error === API_SUCCESS && res.body.data && res.body.data.list) {
            this.existingStrategyNames = res.body.data.list.map((i) => i.strategyName);
          }
          this.addDialogVisible = true;
        })
        .catch(() => {
          this.addDialogVisible = true;
        });
    },
    handleDelete(row) {
      this.$confirm("确认要删除该策略吗？", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      }).then(() => {
        this.$http({
          url: `${this.$util.domain}/adminapi/v1/ad/strategy/delete/${row.id}`,
          method: "POST",
        }).then((res) => {
          if (res.body.error !== API_SUCCESS) {
            this.$message({
              type: "error",
              message: res.body.message || "删除失败",
            });
            return;
          }
          this.$message({
            type: "success",
            message: "删除成功",
          });
          this.queryCustomList();
        });
      });
    },
    handleToggle(row) {
      const next = row.status === "active" ? "expired" : "active";
      const text = row.status === "active" ? "失效" : "启用";
      this.$confirm(`确认要${text}该策略吗？`, "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      }).then(() => {
        row.status = next;
        row.statusText = next === "active" ? "生效中" : "已过期";
        this.$message({
          type: "success",
          message: `${text}成功（示例）`,
        });
      });
    },
    /** 状态列样式：pending 灰、active 绿、expired 橘红 */
    statusRowClass(status) {
      if (status === "active") return "ad-status--active";
      if (status === "pending") return "ad-status--pending";
      if (status === "expired") return "ad-status--expired";
      return "ad-status--pending";
    },
    strategyStatusText(row) {
      if (row.statusText) return row.statusText;
      const map = { active: "生效中", pending: "待生效", expired: "已过期" };
      return map[row.status] || "—";
    },
    /**
     * 开屏 / 插屏类广告位：接口可返回 { cold, hot } 分别表示冷启、热启间隔文案（与弹窗一致）。
     * 信息流等仅开关位仍为字符串，如「展示」「不展示」。
     */
    isColdHotIntervalSlot(val) {
      return (
        val != null &&
        typeof val === "object" &&
        !Array.isArray(val) &&
        Object.prototype.hasOwnProperty.call(val, "cold") &&
        Object.prototype.hasOwnProperty.call(val, "hot")
      );
    },
  },
  watch: {
    activeTab(val) {
      if (val === "crowd") {
        this.crowdPagination.page = 1;
        this.queryCustomCrowdList();
        this.layoutCrowdTables();
      }
    },
    addDialogVisible(val) {
      if (!val) {
        this.strategyDialogEditId = null;
        this.strategyDialogNameExclude = "";
        this.strategyPrefillDto = null;
      }
    },
  },
};
</script>

<style scoped>
.ad-main-offset {
  margin-left: 16px;
}

/* 与上方「广告策略说明」橙色背景左缘对齐（去掉全局 content-wrapper 的左侧 20px） */
.ad-main-offset .content-wrapper {
  padding-left: 0;
}

/* 表格去掉列与列之间的竖向分割线（不使用 border 模式） */
.ad-table >>> th,
.ad-table >>> td {
  border-right: none;
}

/* 人群圈定：无单元格分隔线，表头浅底、正文左对齐 */
.ad-table--crowd {
  border: none;
}

.ad-table--crowd::after,
.ad-table--crowd::before {
  display: none;
}

.ad-table--crowd >>> td,
.ad-table--crowd >>> th {
  border-bottom: none;
  border-right: none;
}

.ad-table--crowd >>> th {
  background-color: #f5f7fa;
  color: #606266;
  font-weight: 600;
}

.ad-table--crowd >>> .cell {
  color: #303133;
  text-align: left;
}

.ad-table >>> .cell-nowrap .cell {
  white-space: nowrap;
}

/* 生效时间：自定义模板两行展示，避免 el-table .cell 吞掉换行 */
.ad-table >>> td.cell-effect-time .cell {
  line-height: 1.55;
}
.effect-time-cell {
  text-align: center;
  font-size: 13px;
  color: #303133;
}
.effect-time-cell__end {
  margin-top: 4px;
}

/* 跑步时段：单元格允许换行（覆盖 el-table 默认 nowrap） */
.ad-table--crowd >>> td.column-running-time .cell {
  white-space: normal;
  word-break: break-word;
}

/* 星期可换行；具体时段（全天/起止时间）整段不换行 */
.running-time-slot-cell {
  line-height: 1.5;
}
.running-time-slot-cell__days {
  margin-bottom: 2px;
  word-break: break-word;
}
.running-time-slot-cell__time {
  white-space: nowrap;
}

/* 操作列：横向滚到最右时保留与滚动区右缘的间距，避免按钮贴边或显示不全 */
.ad-table >>> th.column-op .cell,
.ad-table >>> td.column-op .cell {
  padding-right: 16px;
}

/* 冷启/热启分行展示（开屏、插屏位） */
.ad-slot-cell {
  font-size: 13px;
  line-height: 1.55;
  text-align: center;
}

.ad-slot-line + .ad-slot-line {
  margin-top: 2px;
}

.ad-slot-tag {
  display: inline-block;
  margin-right: 4px;
  color: #909399;
  font-size: 12px;
}

/* 策略状态：圆点 + 文案，点与字同色 */
.ad-status {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  font-size: 13px;
  line-height: 1;
}

.ad-status__dot {
  display: inline-block;
  width: 6px;
  height: 6px;
  margin-right: 6px;
  border-radius: 50%;
  flex-shrink: 0;
  background-color: currentColor;
}

.ad-status__text {
  color: inherit;
}

.ad-status--pending {
  color: #8c8c8c;
}

.ad-status--active {
  color: #52c41a;
}

.ad-status--expired {
  color: #fa541c;
}

.ad-tip {
  margin: 10px 0 14px;
  margin-right: 16px;
  padding: 18px 20px;
  background-color: #fef4ee;
  border: none;
  border-radius: 4px;
}

.ad-tip__title {
  font-weight: 600;
  font-size: 15px;
  color: #333333;
  margin-bottom: 10px;
}

.ad-tip__content {
  font-size: 13px;
  line-height: 1.65;
  color: #333333;
}

.ad-tip__example {
  margin-top: 10px;
  color: #999999;
  font-size: 13px;
  line-height: 1.65;
}

.ad-tabs {
  margin-bottom: 8px;
}

.block-title {
  font-weight: 600;
  margin: 8px 0;
}

.filter-row {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 10px;
  margin: 10px 0 14px;
}

.filter-row--custom-strategy {
  width: 100%;
}

/* 「+新增自定义策略」靠右，与左侧筛选、搜索同一行垂直居中 */
.filter-row--custom-strategy .btn-add-custom-strategy {
  margin-left: auto;
}

/* 与搜索同一行、垂直居中对齐；白底、蓝边框、蓝字（Element plain 主色按钮） */
.btn-add-custom-strategy {
  font-weight: 600;
  background-color: #fff !important;
  color: #409eff !important;
  border-color: #409eff !important;
}

.btn-add-custom-strategy:hover,
.btn-add-custom-strategy:focus {
  background-color: #ecf5ff !important;
  color: #409eff !important;
  border-color: #409eff !important;
}

.custom-strategy-title {
  margin-top: 54px;
  margin-bottom: 4px;
}

.crowd-custom-row {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-top: 48px;
  margin-bottom: 4px;
  padding-right: 20px;
  box-sizing: border-box;
}

.crowd-custom-row__title {
  margin: 0;
}

.filter-item {
  width: 220px;
}

.pagination-row {
  display: flex;
  justify-content: flex-end;
  margin-top: 14px;
}

.op-btns {
  display: inline-flex;
  align-items: center;
  gap: 14px;
  white-space: nowrap;
}

.op-btns--wrap {
  flex-wrap: wrap;
  gap: 6px 14px;
  white-space: normal;
}

.op-btns--left {
  justify-content: flex-start;
}

.danger-text {
  color: #f56c6c;
}

.empty-wrapper {
  padding: 30px 20px;
}

.empty-text {
  color: #909399;
  font-size: 14px;
}
</style>




// WEBPACK FOOTER //
// AdManagementNew.vue?a055b7f2